module.exports = __webpack_public_path__ + "img/shop-photo7.2628f2dd.jpg";